import styled from 'styled-components';

import { LinearProgressBar } from '@/ui/ProgressBar';

export const Progress = styled(LinearProgressBar)`
  position: absolute;
  width: 100%;
  height: 4px;
`;
